"use client";

import clsx from "clsx";
import Link from "next/link";
import { useEffect } from "react";
import HumburgerMenu from "@/components/base/header/menu/HamburgerMenu";
import { ToastProvider } from "@/components/ui/toast";
import { userStore } from "@/store/userStore";
import useHeader from "./Header.hook";
import styles from "./Header.module.scss";
import { Typography } from "@/components/ui/toast/typography";
import Image from "next/image";
import logo from "@public/logo.svg";
type Props = {
	user: any;
};

/**
 * ヘッダー コンポーネント
 * @returns {JSX.Element} ヘッダー コンポーネント
 */
export default function Header(props: Props) {
	const { user } = props;

	// ログイン状態の監視を行います。
	const { setUser } = userStore();
	useEffect(() => {
		setUser({
			id: user ? user.id : "",
			email: user ? user.email! : "",
		});
	}, [user, setUser]);

	const { isOpen, handleMenu, handleMenuClose, logout } = useHeader();

	return (
		<ToastProvider>
			<header className={styles.header}>
				<div className={styles.headerLeft}>
					<Image
						src={logo}
						alt="logo"
						width={100}
						height={100}
						className={styles.logo}
					/>

					<Link
						href="/"
						className={styles.serviceName}
						onClick={handleMenuClose}
					>
						<Typography tag="p" className={styles.serviceName}>
							オリコット
						</Typography>
					</Link>
				</div>
				<div className={styles.headerRight}>
					<ul className={styles.navigation}>
						<li>
							<Link href="./design" className={styles.menu}>
								新規作成
							</Link>
						</li>
						{user && (
							<li>
								<Link href="./mydesign" className={styles.menu}>
									マイデザイン
								</Link>
							</li>
						)}
						<li>
							{user ? (
								<p
									onClick={logout}
									className={clsx(styles.menu, styles.logout)}
								>
									ログアウト
								</p>
							) : (
								<Link href="./login" className={styles.menu}>
									ログイン
								</Link>
							)}
						</li>
					</ul>
					<div className={styles.humbergerMenu}>
						<HumburgerMenu
							user={user}
							handleMenu={handleMenu}
							isOpen={isOpen}
							logout={logout}
						/>
					</div>
				</div>
			</header>
		</ToastProvider>
	);
}
